import type {
  NfdBrowseCategoryItem,
  NfdBrowseLengthItem,
  NfdBrowseSaleTypeItem,
  NfdBrowseSort,
  NfdBrowseStateItem,
  NfdBrowseTraitsItem
} from 'api/api-client'

export const sortOptions = [
  { value: 'saleTypeAsc' as NfdBrowseSort, label: 'Sale Type' },
  { value: 'createdDesc' as NfdBrowseSort, label: 'Recently Minted' },
  { value: 'soldDesc' as NfdBrowseSort, label: 'Recently Sold' },
  { value: 'priceAsc' as NfdBrowseSort, label: 'Price: Low to High' },
  { value: 'priceDesc' as NfdBrowseSort, label: 'Price: High to Low' },
  { value: 'highestSaleDesc' as NfdBrowseSort, label: 'Highest Last Sale' }
]

export type FilterOption<FilterArrayItem> = {
  label: string
  value: FilterArrayItem
}

export type FilterMap = {
  [key: string]: {
    label: string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options: any[]
  }
}

export const filters: FilterMap = {
  category: {
    label: 'Category',
    options: [
      { value: 'common' as NfdBrowseCategoryItem, label: 'Common' },
      { value: 'premium' as NfdBrowseCategoryItem, label: 'Premium' },
      { value: 'curated' as NfdBrowseCategoryItem, label: 'Curated' }
    ]
  },
  state: {
    label: 'Status',
    options: [
      { value: 'owned' as NfdBrowseStateItem, label: 'Owned' },
      // { value: 'reserved' as NfdBrowseStateItem, label: 'Reserved' },
      { value: 'forSale' as NfdBrowseStateItem, label: 'For Sale' }
      // { value: 'inAuction' as NfdBrowseStateItem, label: 'On Auction' }
    ]
  },
  length: {
    label: 'Length',
    options: [
      { value: '1_letters' as NfdBrowseLengthItem, label: '1 Letter' },
      { value: '2_letters' as NfdBrowseLengthItem, label: '2 Letters' },
      { value: '3_letters' as NfdBrowseLengthItem, label: '3 Letters' },
      { value: '4_letters' as NfdBrowseLengthItem, label: '4 Letters' },
      { value: '5_letters' as NfdBrowseLengthItem, label: '5 Letters' },
      { value: '6_letters' as NfdBrowseLengthItem, label: '6 Letters' },
      { value: '7_letters' as NfdBrowseLengthItem, label: '7 Letters' },
      { value: '8_letters' as NfdBrowseLengthItem, label: '8 Letters' },
      { value: '9_letters' as NfdBrowseLengthItem, label: '9 Letters' },
      { value: '10+_letters' as NfdBrowseLengthItem, label: '10+ Letters' }
    ]
  },
  saleType: {
    label: 'Sale Type',
    options: [
      { value: 'buyItNow' as NfdBrowseSaleTypeItem, label: 'Fixed Price' },
      { value: 'auction' as NfdBrowseSaleTypeItem, label: 'Auction' }
    ]
  },
  traits: {
    label: 'Traits',
    options: [{ value: 'emoji' as NfdBrowseTraitsItem, label: 'Emoji' }]
  }
}
